module.exports = __webpack_public_path__ + "static/media/graph.8eb825b9.svg";